export type CreditSearchDraft = {
  date_from: string;
  date_to: string;
  system_type: string;
  type: string;
  keyword: string;
};

export const EMPTY_CREDIT_SEARCH: CreditSearchDraft = {
  date_from: "",
  date_to: "",
  system_type: "",
  type: "",
  keyword: "",
};

export const CREDIT_SYSTEM_OPTIONS = [
  { value: "PARCEL", label: "ส่งพัสดุนอก SKU" },
  { value: "ORDER", label: "คำสั่งซื้อ" },
];

/**
 * ป้ายใน dropdown ให้ตรงกับคอลัมน์「รายการ」ในตาราง (display_label_th)
 * value ยังเป็น type ใน DB สำหรับ filter API
 */
export const CREDIT_TYPE_OPTIONS = [
  { value: "TOPUP", label: "เติมเครดิต" },
  { value: "RESERVE", label: "หักค่าประกันขนส่ง COD 50%" },
  { value: "RELEASE", label: "คืนค่าประกัน COD" },
  { value: "DEDUCT", label: "หักเพิ่มเครดิต / หัก — ส่งพัสดุ" },
  { value: "DEBT", label: "หักเพิ่มเครดิต (เครดิตค้างชำระ)" },
  { value: "DEBT_SETTLEMENT", label: "หักเครดิตค้างชำระ" },
  { value: "REFUND", label: "คืนเครดิต / คืน — ส่งพัสดุ" },
  { value: "EXPIRED", label: "เครดิตหมดอายุ" },
  { value: "MANUAL", label: "ปรับเครดิต (มือ)" },
];

export const systemTypeLabel = (systemType: string | null | undefined): string => {
  if (systemType === "PARCEL") return "ส่งพัสดุนอก SKU";
  if (systemType === "ORDER") return "คำสั่งซื้อ";
  return "—";
};
